import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ReactDOM from 'react-dom';
import VantageHome from './components/vantage/Home';
import StandardCharteredBank from './components/standard-chartered-bank/Home';
import AmexSG from './components/amex/Home';
import HeartistRoute from './components/heartist/HeartistRoute';
import MaintenanceOverlay from './components/common/maintenance-page';

class App extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/vantage" exact component={VantageHome}/>
          <Route path="/test-partner" exact component={StandardCharteredBank}/>
          <Route path="/beyond" exact component={StandardCharteredBank}/>
          {/* <Route path="/amexsiabusiness" exact component={AmexSG}/> */}
          <Route path="/amexsiabusiness" exact component={MaintenanceOverlay}/>
          {/* Heartist without country defaults to AU */}
          <Route path="/heartist" exact>
            <HeartistRoute country="AU" />
          </Route>
          {/* Heartist with country first */}
          <Route path="/:country/heartist" component={HeartistRoute}/>
        </Switch>
      </Router>
    );
  }
}

ReactDOM.render(<App />, document.getElementById('root'));
    

